//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import alSelector from '../../achievement/components/al-selector.vue';
export default {
  components: {
    alSelector,
  },
  props: {
    root: {
      type: String,
      default: '',
    },
    demand: {
      type: Object,
      default: {},
      require: true,
    },
    cooperationTypeList: {
      type: Array,
      default: [],
    },
    demandTypeList: {
      type: Array,
      default: [],
    },
  },
  computed: {
    intendedPrice() {
      return this.demand.intendedPrice == '0'
        ? '面议'
        :'￥'+ Number(this.demand.intendedPrice).toLocaleString();
    },
  },
  data() {
    return {
      detailAddress: '',
    };
  },
  methods: {
    getCooperationType() {
      if (this.demand.cooperationType && this.cooperationTypeList.length > 0) {
        return this.cooperationTypeList.find((_) => {
          return _.dictCode == this.demand.cooperationType;
        }).dictName;
      }
      return '';
    },
    getDemandType() {
      if (this.demand.demandType && this.demandTypeList.length > 0) {
        return this.demandTypeList.find((_) => {
          return _.dictCode == this.demand.demandType;
        }).dictName;
      }
      return '';
    },
    pushToDemandDetail() {
      this.$router.push(`/crowdsourcing/demandDetail?id=${this.demand.demandId}&root=${this.root}`);
    },
  },
};
